module.exports = __webpack_public_path__ + "img/many.5430b6d4.png";